import UAParser from 'ua-parser-js';
const uaparser = new UAParser();
function getProviders() {
        //return `http://playboxcade-next-pbccontentnext6373d11d-1jk30yops1pkh.s3-website-eu-west-1.amazonaws.com/images/${img}?pixi=1`;
  const base = 'https://api.playboxcade.com/latest';
  const assetBase = 'https://assets.playboxcade.com';
  const imageBase = 'http://playboxcade-next-pbccontentnext6373d11d-1jk30yops1pkh.s3-website-eu-west-1.amazonaws.com/images/';
  const soundsBase = 'https://s3-eu-west-1.amazonaws.com/insights-web-assets/sounds';
  //const prodRedirect = 'https://next.playboxcade.com/loggedin';
  //const devR
  return {
    // These need to be contained in an object because providers are not reactive.
    api:{
      makeTracker(siteId, gameId, source) {
        return new Tracker(siteId, gameId, source)
      },
      locateWasmFile(file) {
        if (file === 'https://static.playboxcade.com/box2d-test/box2d.test.3.wasm') {
          return `https://static.playboxcade.com/box2d/box2d.test.3.wasm`
        } else {
          return file;
        }
      },
      loginRedirect($route) {
        if (process.browser) {
          let redirectUrl;
          redirectUrl = `${window ? window.origin : "LEL"}/loggedin`;
          //const url = `https://pbc.auth.eu-west-1.amazoncognito.com/login?response_type=code&client_id=4ic8cd76cdiqq9makat3qhsdqa&redirect_uri=${redirectUrl}`;
          const url = `https://auth.playboxcade.com/login?response_type=code&client_id=4ic8cd76cdiqq9makat3qhsdqa&redirect_uri=${redirectUrl}`;

          if ($route && window.localStorage) {
            try {
              const {name,params} = $route;
              window.localStorage.setItem('loggedInFrom', JSON.stringify({name,params}));
            } catch (e) {
            }
          }
          return url;
        } else {
          return "POS"
        }
      },
      makePublishUrl() {
        return `${base}/publish/${gameId}`
      },
      makeSaveUrl(gameId) {
        return `${base}/signedUrl/edit/${gameId}`
      },
      makeAnonUrl(templateId) {
        return `${base}/anon/${templateId}`
      },
      makeAnonBackupUrl(templateId) {
        return `${base}/anon/${templateId}`
      },
      makeEditUrl(gameId) {
        return `${assetBase}/edit/${gameId}`
      },
      makeEditFeatureUrl(featureId) {
        return `${assetBase}/features/${featureId}`
      },
      makeSaveFeatureUrl(featureId) {
        return `${base}/signedUrl/feature/${featureId}`
      },
      makePublishUrl(gameId) {
        return `${base}/publish/${gameId}`
      },
      isDevSite() {
        return process.browser && (window.location.hostname === 'localhost' || window.location.hostname.includes('10.0.0'));
      },
      makeActivityUrl(id) {
        if (this.isDevSite()) {
          return `${process.env.VUE_APP_CONTENT_BUCKET}activity/${id}`;
        } else {
          return `/activity/${id}`;
        }
      },
      makeStashUrl(id) {
        if (this.isDevSite()) {
          return `${process.env.VUE_APP_CONTENT_BUCKET}poststash/${id}`;
        } else {
          return `/poststash/${id}`;
        }
      },
      makeGameUrl(gameId) {
        return this._makeImageUrl(gameId, 'games');
      },
      makeUrl(path) {
        return `${base}/${path}`
      },
      makeAtlasUrl(atlas) {
        return `${imageBase}/atlas/${atlas}.json`;
      },
      makeSpineUrl(atlas) {
        return `${imageBase}/spine/${atlas}`
      },
      makeImportDataUrl(importId, suffix=undefined) {
        return this._makeImageUrl(importId, 'imports') + (suffix ? ("?" + suffix) : '');
      },
      _makeImageUrl(img, prefix='images') {
        if (!img) {
          return this._makeImageUrl('placeholder.png');
        }
        if (process.browser && uaparser.getBrowser().name.toLowerCase().includes('safari')) {
          img = img.replace('.webp','.png');
        }

        if (img.indexOf('http') === 0) {
          return img;
        }
        if (this.isDevSite()) {
          if (process.env.VUE_APP_CONTENT_BUCKET) {
            if (prefix) {
              return `${process.env.VUE_APP_CONTENT_BUCKET}${prefix}/${img}`;
            } else {
              console.log('here 1');
              return `${process.env.VUE_APP_CONTENT_BUCKET}${img}`;
            }
          } else if (process.env.STORYBOOK_CONTENT_BUCKET) {
            if (prefix) {
              return `${process.env.STORYBOOK_CONTENT_BUCKET}${prefix}/${img}`;
            } else {
              return `${process.env.STORYBOOK_CONTENT_BUCKET}${img}`;
            }
          } else {
            throw new Error('set env variable');
          }
        } else {
          if (prefix) {
            if (process.env.VUE_APP_DOMAIN_NAME) {
              const domain = process.env.VUE_APP_DOMAIN_NAME;
              return `https://${domain}/${prefix}/${img}`;
            } else {
              return `/${prefix}/${img}`;
            }
          } else {
            if (process.env.VUE_APP_DOMAIN_NAME) {
              const domain = process.env.VUE_APP_DOMAIN_NAME;
              return `https://${domain}/${img}`;
            } else {
              return `/${img}`;
            }
          }
        }
      },
      makeAnimationThumbnailUrl(img) {
        if (process.browser && uaparser.getBrowser().name.toLowerCase().includes('safari')) {
          img = img.replace('.webp','.gif');
        }

        return this._makeImageUrl(img, 'animations') + '?ui=1';
      },
      makeImageUrl(img) {
        return this._makeImageUrl(img) + '?pixi=1';
      },
      makeImageUrlEditor(img, extra) {
        // The ?ui=1 makes the cross-origin loading work for PIXI
        // If the user loads the image first using normal <img> tags,
        // and then PIXI tries to load it afterwards, the caching
        // information makes the raw loading fail.
        return this._makeImageUrl(img) + "?ui=1" + (extra ? ('&' + extra) : '');
      },
      makeVideoUrl(img) {
        if (process.browser) {
          const browser = uaparser.getBrowser().name.toLowerCase();
          const isChromiumOrHeadless = browser.includes('chromium') || browser.includes('headless');
          if (isChromiumOrHeadless) {
            img = img.replace('.mp4', '.webm');
          }
        }
        return this._makeImageUrl(img, 'videos') + '?pixi=1';
      },
      makeVideoUrlEditor(img) {
        if (process.browser) {
          const browser = uaparser.getBrowser().name.toLowerCase();
          const isChromiumOrHeadless = browser.includes('chromium') || browser.includes('headless');
          if (isChromiumOrHeadless) {
            img = img.replace('.mp4', '.webm');
          }
        }
        // The ?ui=1 makes the cross-origin loading work for PIXI
        // If the user loads the image first using normal <img> tags,
        // and then PIXI tries to load it afterwards, the caching
        // information makes the raw loading fail.
        return this._makeImageUrl(img, 'videos') + "?ui=1";
      },
      makePackerUrl(id) {
        return this._makeImageUrl(id, 'packer');
      },
      makeSpritesheetUrlEditor(img) {
        // The ?ui=1 makes the cross-origin loading work for PIXI
        // If the user loads the image first using normal <img> tags,
        // and then PIXI tries to load it afterwards, the caching
        // information makes the raw loading fail.
        return this._makeImageUrl(img, 'spritesheets') + "?ui=1";
      },
      makeSpritesheetUrl(img) {
        // The ?ui=1 makes the cross-origin loading work for PIXI
        // If the user loads the image first using normal <img> tags,
        // and then PIXI tries to load it afterwards, the caching
        // information makes the raw loading fail.
        return this._makeImageUrl(img, 'spritesheets') + "?pixi=1";
      },
      makeClipUrl(url) {
        return this._makeImageUrl(url, '');
      },
      makeThumbnailUrlUI(img) {
        return this._makeImageUrl(img, 'thumbnails');
      },
      makeThumbnailUrl(img) {
        return this._makeImageUrl(img, 'thumbnails') + "?pixi=1";
      },
      makeThumbnailUrlEditor(img) {
        // The ?ui=1 makes the cross-origin loading work for PIXI
        // If the user loads the image first using normal <img> tags,
        // and then PIXI tries to load it afterwards, the caching
        // information makes the raw loading fail.
        return this._makeImageUrl(img, 'thumbnails') + "?ui=1";
      },
      makeScreenshotUrlEditor(postId, img) {
        return this._makeImageUrl(img, 'screenshots/' + postId) + "?ui=1";
      },
      makeScreenshotUrlUI(postId, img) {
        return this._makeImageUrl(img, 'screenshots/' + postId);
      },

      makeSoundUrl(sound) {
        return `${soundsBase}/${sound}`;
      },
      makeImageUrlDev(img) {
        const cacheBuster = Math.floor(Math.random() * 10000);
        return `${imageBase}/incoming/${img}`
      },
      makeSignedUrl(type, file) {
        if (type === 'image') {
          return 'https://api.playboxcade.com/latest/signedUrl/image';
        } else if (type === 'sounds') {
          return 'https://api.playboxcade.com/latest/signedUrl/sound';
        } else if (type === 'toy') {
          return 'https://api.playboxcade.com/latest/signedUrl/toy';
        } else if (type === 'spine') {
          return 'https://api.playboxcade.com/latest/signedUrl/spine';
        } else if (type === 'feature') {
          return 'https://api.playboxcade.com/latest/signedUrl/feature';
        } else {
          throw new Error(`dont know type ${type}`);
        }
      },
      makeGameRestUrl(url) {
        return url;
      },
      makeAssetUrl(img) {
        // The ?ui=1 makes the cross-origin loading work for PIXI
        // If the user loads the image first using normal <img> tags,
        // and then PIXI tries to load it afterwards, the caching
        // information makes the raw loading fail.
        return this._makeImageUrl(img, 'img');
      },
      urls:{
        base
      }
    }
  }
}

export default getProviders;
